<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="公司编码（appKey）" prop="appKey">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.appKey"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="授权码（secretKey）" prop="secretKey">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.secretKey"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="产品请求地址" prop="url">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.url"
          :maxLength="100"
        />
      </a-form-model-item>
      <a-form-model-item label="订单请求地址" prop="orderUrl">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.orderUrl"
          :maxLength="100"
        />
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 9, offset: 3 }">
        <a-button
          htmlType="submit"
          type="primary"
          @click="submitEvent"
          :loading="submitLoading"
        >保存
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import SjlHotelMixins from '@/views/service/serviceProvider/sjlHotel/mixins/SjlHotelMixins'

export default {
  name: 'SjlHotelApiConfigure',
  mixins: [SjlHotelMixins],
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 10 },
      ruleForm: {},
      tabRule: {
        appKey: [
          { required: true, message: '请输入公司编码（appKey）', trigger: ['blur', 'change'] }
        ],
        secretKey: [
          { required: true, message: '请输入授权码（secretKey）', trigger: ['blur', 'change'] }
        ],
        url: [
          { required: true, message: '请输入产品请求地址', trigger: ['blur', 'change'] }
        ],
        orderUrl: [
          { required: true, message: '请输入订单请求地址', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getServerApiService().post('shenjie/query', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res) this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
        const url = params.id ? 'shenjie/update' : 'shenjie/add'
        this.getHttpServices().getServerApiService().post(url, params).then(res => {
          this.$message.success('API配置成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
